export const collection = {
    noData: 'あなたはまだ NFT を所有していません。',
    title: 'あなたのコレクション',
};
